import { Injectable } from "@nestjs/common";
import { RmEvaluationSamples } from "../rm-evaluation-samples.entity";
import { RmEvaluationSamplesInfo } from "./rm-evaluation-samples.dto";

@Injectable()
export class RmEvaluationSamplesAdapter{
    public convertDtoToEntity(dto: RmEvaluationSamplesInfo, rmEvalId?: number): RmEvaluationSamples{
        const entity = new RmEvaluationSamples;
        entity.rmEvaluationId = rmEvalId;
        entity.time = dto.time;
        entity.species = dto.species;
        entity.temperature = dto.temperature;
        entity.generalAppearance = dto.generalAppearance;
        entity.generalOdour = dto.generalOdour;
        entity.freshness = dto.freshness;
        entity.dehydration = dto.dehydration;
        entity.discolouration = dto.discolouration;
        entity.deterioration = dto.deterioration;
        entity.blackSpotOrTail = dto.blackSpotOrTail;
        entity.looseShells = dto.looseShells;
        entity.brokenOrDamagedPcs = dto.brokenOrDamagedPcs;
        entity.fungalGrowth = dto.fungalGrowth;
        entity.softSpecies = dto.softSpecies;
        entity.droopingHead = dto.droopingHead;
        entity.foreignMatter = dto.foreignMatter;
        entity.sulphiteKit = dto.sulphiteKit;
        entity.pests = dto.pests;
        entity.muddyOdour = dto.muddyOdour;
        entity.cookedTexture = dto.cookedTexture;
        entity.cookedFlavor = dto.cookedFlavor;
        entity.parasite = dto.parasite;
        entity.sampleNo=dto.sampleNo;
        if(dto.rmEvaluationSampleId){
            entity.rmEvaluationSampleId = dto.rmEvaluationSampleId;
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.createdUser = dto.createdUser;
        }
        
        return entity;
    }

    public convertEntityToDto(entity: RmEvaluationSamples): RmEvaluationSamplesInfo{
        const dto = new RmEvaluationSamplesInfo;
        dto.rmEvaluationSampleId = entity.rmEvaluationSampleId;
        dto.rmEvaluationId = entity.rmEvaluationId;
        dto.time = entity.time;
        dto.species = entity.species;
        dto.temperature = entity.temperature;
        dto.generalAppearance = entity.generalAppearance;
        dto.generalOdour = entity.generalOdour;
        dto.freshness = entity.freshness;
        dto.dehydration = entity.dehydration;
        dto.discolouration = entity.discolouration;
        dto.deterioration = entity.deterioration;
        dto.blackSpotOrTail = entity.blackSpotOrTail;
        dto.looseShells = entity.looseShells;
        dto.brokenOrDamagedPcs = entity.brokenOrDamagedPcs;
        dto.fungalGrowth = entity.fungalGrowth;
        dto.softSpecies = entity.softSpecies;
        dto.droopingHead = entity.droopingHead;
        dto.foreignMatter = entity.foreignMatter;
        dto.sulphiteKit = entity.sulphiteKit;
        dto.pests = entity.pests;
        dto.muddyOdour = entity.muddyOdour;
        dto.cookedTexture = entity.cookedTexture;
        dto.cookedFlavor = entity.cookedFlavor;
        dto.parasite = entity.parasite;
        dto.createdUser = entity.createdUser;
        dto.createdAt = entity.createdAt;
        dto.updatedUser = entity.updatedUser;
        dto.updatedAt = entity.updatedAt;
        dto.versionFlag = entity.versionFlag;       
        dto.sampleNo = entity.sampleNo; 
        return dto;
    }
}